import { EMBEDDED_APPRAISAL_FLOW_EXPERIMENT } from '~/constants/common/embeddedAppraisalFlow';
import { useIsNativeIOS } from '~/context/common/DeviceContext';
import useExperimentBucket from '~/hooks/common/experiments/useExperimentBucket';

export default function useIsInAppraisalModalExperiment(): boolean {
  const bucket = useExperimentBucket(EMBEDDED_APPRAISAL_FLOW_EXPERIMENT);
  const isNativeIOS = useIsNativeIOS();

  return !isNativeIOS && bucket === 'treatment';
}
